// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var React$1 = require("simple-icons/icons/react");
var Github = require("simple-icons/icons/github");
var Reason = require("simple-icons/icons/reason");
var D3DotJs = require("simple-icons/icons/d3-dot-js");
var NodeDotJs = require("simple-icons/icons/node-dot-js");
var Simpleicons = require("simple-icons/icons/simpleicons");

var ChevronLeft = {};

var ChevronDown = {};

var Data = Reason;

function Icons$MakeSimpleIcon(Props) {
  var heightOpt = Props.height;
  var widthOpt = Props.width;
  var classNameOpt = Props.className;
  var styleOpt = Props.style;
  var fillOpt = Props.fill;
  var ariaLabelOpt = Props.ariaLabel;
  var ariaHiddenOpt = Props.ariaHidden;
  var height = heightOpt !== undefined ? heightOpt : "24";
  var width = widthOpt !== undefined ? widthOpt : "24";
  var className = classNameOpt !== undefined ? classNameOpt : "";
  var style = styleOpt !== undefined ? Caml_option.valFromOption(styleOpt) : ({});
  var fill = fillOpt !== undefined ? fillOpt : "#" + Data.hex;
  var ariaLabel = ariaLabelOpt !== undefined ? ariaLabelOpt : Data.title + " Icon";
  var ariaHidden = ariaHiddenOpt !== undefined ? ariaHiddenOpt : false;
  return React.createElement("svg", {
              "aria-hidden": ariaHidden,
              "aria-label": ariaLabel,
              className: className,
              role: "img",
              style: style,
              height: height,
              width: width,
              viewBox: "0 0 24 24"
            }, React.createElement("path", {
                  d: Data.path,
                  fill: fill
                }));
}

Icons$MakeSimpleIcon.displayName = Data.title;

var Reason$1 = {
  make: Icons$MakeSimpleIcon
};

var Data$1 = D3DotJs;

function Icons$MakeSimpleIcon$1(Props) {
  var heightOpt = Props.height;
  var widthOpt = Props.width;
  var classNameOpt = Props.className;
  var styleOpt = Props.style;
  var fillOpt = Props.fill;
  var ariaLabelOpt = Props.ariaLabel;
  var ariaHiddenOpt = Props.ariaHidden;
  var height = heightOpt !== undefined ? heightOpt : "24";
  var width = widthOpt !== undefined ? widthOpt : "24";
  var className = classNameOpt !== undefined ? classNameOpt : "";
  var style = styleOpt !== undefined ? Caml_option.valFromOption(styleOpt) : ({});
  var fill = fillOpt !== undefined ? fillOpt : "#" + Data$1.hex;
  var ariaLabel = ariaLabelOpt !== undefined ? ariaLabelOpt : Data$1.title + " Icon";
  var ariaHidden = ariaHiddenOpt !== undefined ? ariaHiddenOpt : false;
  return React.createElement("svg", {
              "aria-hidden": ariaHidden,
              "aria-label": ariaLabel,
              className: className,
              role: "img",
              style: style,
              height: height,
              width: width,
              viewBox: "0 0 24 24"
            }, React.createElement("path", {
                  d: Data$1.path,
                  fill: fill
                }));
}

Icons$MakeSimpleIcon$1.displayName = Data$1.title;

var D3 = {
  make: Icons$MakeSimpleIcon$1
};

var Data$2 = Github;

function Icons$MakeSimpleIcon$2(Props) {
  var heightOpt = Props.height;
  var widthOpt = Props.width;
  var classNameOpt = Props.className;
  var styleOpt = Props.style;
  var fillOpt = Props.fill;
  var ariaLabelOpt = Props.ariaLabel;
  var ariaHiddenOpt = Props.ariaHidden;
  var height = heightOpt !== undefined ? heightOpt : "24";
  var width = widthOpt !== undefined ? widthOpt : "24";
  var className = classNameOpt !== undefined ? classNameOpt : "";
  var style = styleOpt !== undefined ? Caml_option.valFromOption(styleOpt) : ({});
  var fill = fillOpt !== undefined ? fillOpt : "#" + Data$2.hex;
  var ariaLabel = ariaLabelOpt !== undefined ? ariaLabelOpt : Data$2.title + " Icon";
  var ariaHidden = ariaHiddenOpt !== undefined ? ariaHiddenOpt : false;
  return React.createElement("svg", {
              "aria-hidden": ariaHidden,
              "aria-label": ariaLabel,
              className: className,
              role: "img",
              style: style,
              height: height,
              width: width,
              viewBox: "0 0 24 24"
            }, React.createElement("path", {
                  d: Data$2.path,
                  fill: fill
                }));
}

Icons$MakeSimpleIcon$2.displayName = Data$2.title;

var GitHub = {
  make: Icons$MakeSimpleIcon$2
};

var Data$3 = NodeDotJs;

function Icons$MakeSimpleIcon$3(Props) {
  var heightOpt = Props.height;
  var widthOpt = Props.width;
  var classNameOpt = Props.className;
  var styleOpt = Props.style;
  var fillOpt = Props.fill;
  var ariaLabelOpt = Props.ariaLabel;
  var ariaHiddenOpt = Props.ariaHidden;
  var height = heightOpt !== undefined ? heightOpt : "24";
  var width = widthOpt !== undefined ? widthOpt : "24";
  var className = classNameOpt !== undefined ? classNameOpt : "";
  var style = styleOpt !== undefined ? Caml_option.valFromOption(styleOpt) : ({});
  var fill = fillOpt !== undefined ? fillOpt : "#" + Data$3.hex;
  var ariaLabel = ariaLabelOpt !== undefined ? ariaLabelOpt : Data$3.title + " Icon";
  var ariaHidden = ariaHiddenOpt !== undefined ? ariaHiddenOpt : false;
  return React.createElement("svg", {
              "aria-hidden": ariaHidden,
              "aria-label": ariaLabel,
              className: className,
              role: "img",
              style: style,
              height: height,
              width: width,
              viewBox: "0 0 24 24"
            }, React.createElement("path", {
                  d: Data$3.path,
                  fill: fill
                }));
}

Icons$MakeSimpleIcon$3.displayName = Data$3.title;

var NodeJs = {
  make: Icons$MakeSimpleIcon$3
};

var Data$4 = Simpleicons;

function Icons$MakeSimpleIcon$4(Props) {
  var heightOpt = Props.height;
  var widthOpt = Props.width;
  var classNameOpt = Props.className;
  var styleOpt = Props.style;
  var fillOpt = Props.fill;
  var ariaLabelOpt = Props.ariaLabel;
  var ariaHiddenOpt = Props.ariaHidden;
  var height = heightOpt !== undefined ? heightOpt : "24";
  var width = widthOpt !== undefined ? widthOpt : "24";
  var className = classNameOpt !== undefined ? classNameOpt : "";
  var style = styleOpt !== undefined ? Caml_option.valFromOption(styleOpt) : ({});
  var fill = fillOpt !== undefined ? fillOpt : "#" + Data$4.hex;
  var ariaLabel = ariaLabelOpt !== undefined ? ariaLabelOpt : Data$4.title + " Icon";
  var ariaHidden = ariaHiddenOpt !== undefined ? ariaHiddenOpt : false;
  return React.createElement("svg", {
              "aria-hidden": ariaHidden,
              "aria-label": ariaLabel,
              className: className,
              role: "img",
              style: style,
              height: height,
              width: width,
              viewBox: "0 0 24 24"
            }, React.createElement("path", {
                  d: Data$4.path,
                  fill: fill
                }));
}

Icons$MakeSimpleIcon$4.displayName = Data$4.title;

var SimpleIcons = {
  make: Icons$MakeSimpleIcon$4
};

var Data$5 = React$1;

function Icons$MakeSimpleIcon$5(Props) {
  var heightOpt = Props.height;
  var widthOpt = Props.width;
  var classNameOpt = Props.className;
  var styleOpt = Props.style;
  var fillOpt = Props.fill;
  var ariaLabelOpt = Props.ariaLabel;
  var ariaHiddenOpt = Props.ariaHidden;
  var height = heightOpt !== undefined ? heightOpt : "24";
  var width = widthOpt !== undefined ? widthOpt : "24";
  var className = classNameOpt !== undefined ? classNameOpt : "";
  var style = styleOpt !== undefined ? Caml_option.valFromOption(styleOpt) : ({});
  var fill = fillOpt !== undefined ? fillOpt : "#" + Data$5.hex;
  var ariaLabel = ariaLabelOpt !== undefined ? ariaLabelOpt : Data$5.title + " Icon";
  var ariaHidden = ariaHiddenOpt !== undefined ? ariaHiddenOpt : false;
  return React.createElement("svg", {
              "aria-hidden": ariaHidden,
              "aria-label": ariaLabel,
              className: className,
              role: "img",
              style: style,
              height: height,
              width: width,
              viewBox: "0 0 24 24"
            }, React.createElement("path", {
                  d: Data$5.path,
                  fill: fill
                }));
}

Icons$MakeSimpleIcon$5.displayName = Data$5.title;

var React$2 = {
  make: Icons$MakeSimpleIcon$5
};

exports.ChevronLeft = ChevronLeft;
exports.ChevronDown = ChevronDown;
exports.Reason = Reason$1;
exports.D3 = D3;
exports.GitHub = GitHub;
exports.NodeJs = NodeJs;
exports.SimpleIcons = SimpleIcons;
exports.React = React$2;
/* Data Not a pure module */
